export type ReplicateErrorKind =
  | 'unauthorized'
  | 'rate-limited'
  | 'invalid-input'
  | 'model-not-found'
  | 'cors'
  | 'network'
  | 'aborted'
  | 'unknown';

export class ReplicateError extends Error {
  override readonly name = 'ReplicateError';
  constructor(
    public readonly kind: ReplicateErrorKind,
    message: string,
    public readonly status?: number,
    public override readonly cause?: unknown,
  ) {
    super(message);
  }
}

export function classifyHttpError(status: number, body: string): ReplicateError {
  if (status === 401 || status === 403)
    return new ReplicateError('unauthorized', 'Replicate token rejected.', status);
  if (status === 404)
    return new ReplicateError('model-not-found', 'Model or prediction not found.', status);
  if (status === 422)
    return new ReplicateError('invalid-input', `Invalid input: ${body.slice(0, 300)}`, status);
  if (status === 429)
    return new ReplicateError('rate-limited', 'Rate limited by Replicate.', status);
  return new ReplicateError(
    'unknown',
    `Replicate ${status}: ${body.slice(0, 300)}`,
    status,
  );
}
